import React from 'react';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import ContentCourseFailureAttemptRateTableContainer from './course/ContentCourseFailureAttemptRateTableContainer';
import ContentCourseErrorRateTableContainer from './course/ContentCourseErrorRateTableContainer';
import ContentCourseRepeatRateTableContainer from './course/ContentCourseRepeatRateTableContainer';
import ContentCourseSpeechRateTableContainer from './course/ContentCourseSpeechRateTableContainer';

const ContentCourseListScene = () => (
  <div>
    <Row>
      <Column size={6}>
        <ContentCourseFailureAttemptRateTableContainer />
      </Column>
      <Column size={6}>
        <ContentCourseRepeatRateTableContainer />
      </Column>
    </Row>
    <Separator />
    <Row>
      <Column size={6}>
        <ContentCourseSpeechRateTableContainer />
      </Column>
      <Column size={6}>
        <ContentCourseErrorRateTableContainer />
      </Column>
    </Row>
  </div>
);

export default ContentCourseListScene;
